export const NON_STANDARD_SYMBOL = Symbol('non-standard');
